import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_d93d4i84y7: FaireBrandEntity = {
  token: "b_d93d4i84y7",
  type: "brand",
  name: "Paper Peony Press",
  avatarUrl:
    "https://cdn.faire.com/fastly/361e60131f7c41c96eca065bc65d59dc69461b03edda7f511483ea36ca9c2711.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/f66a3b6582fc81ed4b9ec5791cb7b3f13789149bc19ad3bd7702ced2707396e7.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/361e60131f7c41c96eca065bc65d59dc69461b03edda7f511483ea36ca9c2711.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/f66a3b6582fc81ed4b9ec5791cb7b3f13789149bc19ad3bd7702ced2707396e7.jpeg",
  location: "San Antonio, TX, USA",
  minimumOrderDollars: 139,
  rating: 5,
  reviewCount: 66,
  isTopShop: true,
  isInsider: true,
  description:
    "We are a boutique publishing company focused on creating beautiful books with purpose! Based in Texas, we work with artists and writers around the country to create content that we hope adds a bit of joy to the lives of our readers! ",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:22.772Z",
    importedBy: "entity-db-cli",
  },
};
